export default __webpack_public_path__ + "static/media/nc100bw.43079740.png";